<div class="row">
    <div class="col">
        <nav class="nav-tree bg-white">
            <ul class="nav flex-column">
                <li class="nav-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <a class="nav-link" href="#">
                            <i class="bi bi-chevron-down"></i>
                        </a>
                        <a class="nav-link flex-grow-1" href="#">
                            root회사
                        </a>
                        <div class="d-flex align-items-center">
                            <a class="nav-link" href="#">
                                <i class="bi bi-plus"></i>
                            </a>
                            <a class="nav-link flex-grow-1" href="#">
                                <i class="bi bi-dash"></i>
                            </a>
                        </div>
                    </div>
                    <ul class="nav flex-column">
                        <li class="nav-item">
                            <div class="d-flex align-items-center justify-content-between">
                                <a class="nav-link" href="#">
                                    <i class="bi bi-chevron-right"></i>
                                </a>
                                <a class="nav-link flex-grow-1" href="#">
                                    자회사-01
                                </a>
                                <div class="d-flex align-items-center">
                                    <a class="nav-link" href="#">
                                        <i class="bi bi-plus"></i>
                                    </a>
                                    <a class="nav-link flex-grow-1" href="#">
                                        <i class="bi bi-dash"></i>
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item">
                            <div class="d-flex align-items-center justify-content-between">
                                <a class="nav-link" href="#">
                                    <i class="bi bi-chevron-down"></i>
                                </a>
                                <a class="nav-link flex-grow-1 active" href="#">
                                    자회사-02
                                </a>
                                <div class="d-flex align-items-center">
                                    <a class="nav-link" href="#">
                                        <i class="bi bi-plus"></i>
                                    </a>
                                    <a class="nav-link flex-grow-1" href="#">
                                        <i class="bi bi-dash"></i>
                                    </a>
                                </div>
                            </div>
                            <ul class="nav flex-column">
                                <li class="nav-item">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <a class="nav-link" href="#">
                                            <i class="bi bi-chevron-right"></i>
                                        </a>
                                        <a class="nav-link flex-grow-1" href="#">
                                            자회사-02-01
                                        </a>
                                        <div class="d-flex align-items-center">
                                            <a class="nav-link" href="#">
                                                <i class="bi bi-plus"></i>
                                            </a>
                                            <a class="nav-link flex-grow-1" href="#">
                                                <i class="bi bi-dash"></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <a class="nav-link" href="#">
                                            <i class="bi bi-chevron-right"></i>
                                        </a>
                                        <a class="nav-link flex-grow-1" href="#">
                                            자회사-02-02
                                        </a>
                                        <div class="d-flex align-items-center">
                                            <a class="nav-link" href="#">
                                                <i class="bi bi-plus"></i>
                                            </a>
                                            <a class="nav-link flex-grow-1" href="#">
                                                <i class="bi bi-dash"></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    </div>
    <div class="col">
        <button type="button" class="btn btn-primary"
            (click)="clickShowDriveHis($event)">
            drive his test
        </button>
    </div>
    <div class="col">
        <div class="overflow-auto bg-white" style="height: 100px;">
            <table class="table table-sm table-hover align-items-center text-nowrap mb-0">
                <thead class="bg-white">
                    <tr class="text-center bg-white">
                        <th class="bg-white" style="position: sticky;top:0;">id</th>
                        <th class="bg-white" style="position: sticky;top:0;">carNo</th>
                        <th class="bg-white" style="position: sticky;top:0;">unitId</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-nowrap text-center bg-white" *ngFor="let item of listItems;">
                        <td class="bg-white">{{item.id}}</td>
                        <td class="bg-white">{{item.carNo}}</td>
                        <td class="bg-white">{{item.unitId}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="row mt-5">
    <div class="col">
        <div class="fvms-tree bg-white p-2">
            <ul class="fvms-tree-list">
                <li class="fvms-tree-item">
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-link text-secondary pr-1">
                            <i class="bi bi-chevron-down"></i>
                        </button>
                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                            root회사
                        </div>
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-01
                                </div>
                            </div>
                        </li>
                        <li class="fvms-tree-item active">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-down"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-02
                                </div>
                            </div>
                            <ul class="fvms-tree-list">
                                <li class="fvms-tree-item">
                                    <div class="d-flex align-items-center">
                                        <button type="button" class="btn btn-link text-secondary pr-1">
                                            <i class="bi bi-chevron-right"></i>
                                        </button>
                                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                                            자회사-02-01
                                        </div>
                                    </div>
                                </li>
                                <li class="fvms-tree-item">
                                    <div class="d-flex align-items-center">
                                        <button type="button" class="btn btn-link text-secondary pr-1">
                                            <i class="bi bi-chevron-right"></i>
                                        </button>
                                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                                            자회사-02-02
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li class="fvms-tree-item">
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-link text-secondary pr-1">
                            <i class="bi bi-chevron-down"></i>
                        </button>
                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                            root회사
                        </div>
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-01
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
            <hr>
            <div class="fvms-tree-subject">
                <i class="bi bi-box"></i>
                메뉴 구분 제목
            </div>
            <div class="fvms-tree-item">
                <div class="fvms-tree-label">
                    <i class="bi bi-box"></i>
                    이런메뉴
                </div>
            </div>
            <div class="fvms-tree-item">
                <div class="fvms-tree-label">
                    <i class="bi bi-box"></i>
                    저런메뉴
                </div>
            </div>
            <hr>
            <ul class="fvms-tree-list">
                <li class="fvms-tree-item">
                    <div class="fvms-tree-subject">
                        <i class="bi bi-box"></i>
                        메뉴 구분 제목
                    </div>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label d-flex justify-content-between align-items-center">
                        <div>
                            <i class="bi bi-box"></i>
                            회사관리
                        </div>
                        <span class="badge badge-pill badge-warning">123</span>
                    </div>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        차량관리
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="fvms-tree-label">
                                <i class="bi bi-box"></i>
                                소속차량관리
                            </div>
                        </li>
                        <li class="fvms-tree-item">
                            <div class="fvms-tree-label">
                                <i class="bi bi-box"></i>
                                공급차량관리
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        사용자관리
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col">
        <div class="fvms-tree fvms-tree-sm bg-white p-2">
            <ul class="fvms-tree-list">
                <li class="fvms-tree-item">
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-sm btn-link text-secondary pr-1">
                            <i class="bi bi-chevron-down"></i>
                        </button>
                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                            root회사
                        </div>
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-sm btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-01
                                </div>
                            </div>
                        </li>
                        <li class="fvms-tree-item active">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-sm btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-down"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-02
                                </div>
                            </div>
                            <ul class="fvms-tree-list">
                                <li class="fvms-tree-item">
                                    <div class="d-flex align-items-center">
                                        <button type="button" class="btn btn-sm btn-link text-secondary pr-1">
                                            <i class="bi bi-chevron-right"></i>
                                        </button>
                                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                                            자회사-02-01
                                        </div>
                                    </div>
                                </li>
                                <li class="fvms-tree-item">
                                    <div class="d-flex align-items-center">
                                        <button type="button" class="btn btn-sm btn-link text-secondary pr-1">
                                            <i class="bi bi-chevron-right"></i>
                                        </button>
                                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                                            자회사-02-02
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li class="fvms-tree-item">
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-sm btn-link text-secondary pr-1">
                            <i class="bi bi-chevron-down"></i>
                        </button>
                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                            root회사
                        </div>
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-sm btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-01
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
            <hr>
            <div class="fvms-tree-subject">
                <i class="bi bi-box"></i>
                메뉴 구분 제목
            </div>
            <ul class="fvms-tree-list">
                <li class="fvms-tree-item">
                    <div class="fvms-tree-subject">
                        <i class="bi bi-box"></i>
                        메뉴 구분 제목
                    </div>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        회사관리
                    </div>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        차량관리
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="fvms-tree-label">
                                <i class="bi bi-box"></i>
                                소속차량관리
                            </div>
                        </li>
                        <li class="fvms-tree-item">
                            <div class="fvms-tree-label">
                                <i class="bi bi-box"></i>
                                공급차량관리
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        사용자관리
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col">
        <div class="fvms-tree fvms-tree-lg bg-white p-2">
            <ul class="fvms-tree-list">
                <li class="fvms-tree-item">
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-lg btn-link text-secondary pr-1">
                            <i class="bi bi-chevron-down"></i>
                        </button>
                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                            root회사
                        </div>
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-lg btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-01
                                </div>
                            </div>
                        </li>
                        <li class="fvms-tree-item active">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-lg btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-down"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-02
                                </div>
                            </div>
                            <ul class="fvms-tree-list">
                                <li class="fvms-tree-item">
                                    <div class="d-flex align-items-center">
                                        <button type="button" class="btn btn-lg btn-link text-secondary pr-1">
                                            <i class="bi bi-chevron-right"></i>
                                        </button>
                                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                                            자회사-02-01
                                        </div>
                                    </div>
                                </li>
                                <li class="fvms-tree-item">
                                    <div class="d-flex align-items-center">
                                        <button type="button" class="btn btn-lg btn-link text-secondary pr-1">
                                            <i class="bi bi-chevron-right"></i>
                                        </button>
                                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                                            자회사-02-02
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li class="fvms-tree-item">
                    <div class="d-flex align-items-center">
                        <button type="button" class="btn btn-lg btn-link text-secondary pr-1">
                            <i class="bi bi-chevron-down"></i>
                        </button>
                        <div class="fvms-tree-label text-nowrap flex-grow-1">
                            root회사
                        </div>
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-lg btn-link text-secondary pr-1">
                                    <i class="bi bi-chevron-right"></i>
                                </button>
                                <div class="fvms-tree-label text-nowrap flex-grow-1">
                                    자회사-01
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
            <hr>
            <div class="fvms-tree-subject">
                <i class="bi bi-box"></i>
                메뉴 구분 제목
            </div>
            <ul class="fvms-tree-list">
                <li class="fvms-tree-item">
                    <div class="fvms-tree-subject">
                        <i class="bi bi-box"></i>
                        메뉴 구분 제목
                    </div>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        회사관리
                    </div>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        차량관리
                    </div>
                    <ul class="fvms-tree-list">
                        <li class="fvms-tree-item">
                            <div class="fvms-tree-label">
                                <i class="bi bi-box"></i>
                                소속차량관리
                            </div>
                        </li>
                        <li class="fvms-tree-item">
                            <div class="fvms-tree-label">
                                <i class="bi bi-box"></i>
                                공급차량관리
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="fvms-tree-item">
                    <div class="fvms-tree-label">
                        <i class="bi bi-box"></i>
                        사용자관리
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>